import { Component, OnInit, NgZone } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { AlertController, ModalController } from '@ionic/angular';
import { DBService } from 'src/app/services/db.service';
import { QRScanInfoComponent } from 'src/app/components/qrscan-info/qrscan-info.component';
import { Table } from 'src/app/models/table.model';
import { AlertService } from '../../../services/alert.service';
import { Router } from '@angular/router';

const ADD_TABLE: number = 0;
const CHANGE_QR: number = 1;

@Component({
  selector: 'app-edit-table',
  templateUrl: './edit-table.page.html',
  styleUrls: ['./edit-table.page.scss'],
})
export class EditTablePage implements OnInit {

  constructor(public db:DBService, public util:UtilService, private ngZone:NgZone, private router:Router,
    private alertCtrl:AlertController, private modalController:ModalController, private alert:AlertService) { }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }
  }

  private changeQRCode(table: Table, qrCode: string) {
    table.qrCode = qrCode;
  }

  async deleteTable(table: Table) {
    this.alert.presentAlertConfirm(this, (ref) => {
      ref.db.currentRestaurant.tables = ref.util.deleteFromArray(ref.db.currentRestaurant.tables, table)
      ref.ngZone.run(() => console.log("force ui update"))
    }, 'Tisch entfernen?', 'Möchtest du diesen Tisch wirklich entfernen?')
  }

  //Zuerst scan, dann askForTableName und dann diese Methode
  private addTable(name: string, qrCode: string) {
    //TODO max. Groessen festlegen!!!
    //TODO keine doppelten
    let table: Table = new Table(name)
    table.qrCode = qrCode;
    this.db.currentRestaurant.tables.push(table)
    this.ngZone.run(() => console.log("force ui update"))
  }

  async askForTableName(qrCode: string = '', table?: Table) {
    const alert = await this.alertCtrl.create({
      header: 'Wie soll der Tisch benannt werden?',
      cssClass: 'myAlert',
      inputs: [
        {
          name: 'tablename',
          type: 'text',
          value: table ? table.name : 'Tisch ?'
        }
      ],
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          cssClass: 'alert-button',
          handler: () => {
            this.util.log('Confirm Cancel');
          }
        }, {
          text: 'Übenehmen',
          cssClass: 'alert-button',
          handler: (data) => {
            if (!data.tablename || ('' + data.tablename).length === 0) {
              if (!table) this.addTable("Unbekannt", qrCode)
            } else {
              if (table) {
                table.name = data.tablename.toString()
              } else {
                this.addTable(data.tablename.toString(), qrCode)
              }
            }
          }
        }
      ]
    });
    await alert.present();
  }

  /**
   * 
   * @param mode 0 = Hinzufuegen, 1 = Change QR
   */
  public async scanQRCode(mode: number, table?: Table) {
    //Erstmal max. Tische testen
    if (this.db.currentRestaurant.tables.length >= this.db.currentRestaurant.maxTables) {
      this.util.presentToast('Sie haben die maximale Tischanzahl erreicht - Jetzt upgraden oder entfernen Sie vorhandene Tische')

      return
    }

    //1. Show him the image, how it works
    const modal = await this.modalController.create({
      component: QRScanInfoComponent
    });

    await modal.present();
    await modal.onDidDismiss().then((barcodeData: any) => {

      this.util.isModalOpen = false
      //console.log("QR Code Data",barcodeData)
      //********************************************** */
      // Optionally request the permission early
      if (barcodeData.data) { // text: "...", format: "QR_CODE"
        if (this.db.currentRestaurant.tables.find((table: Table) => table.qrCode === barcodeData.data) !== undefined) {
          this.util.presentToast('Dieser QR Code ist bereits einem anderen Tisch zugeordnet.')
          return
        }

        if (mode === ADD_TABLE) {
          this.askForTableName(barcodeData.data)
        } else {
          this.changeQRCode(table, barcodeData.data)
        }
      } else {
        this.util.presentToast('QR-Code des Tisches konnte nicht eingelesen werden.')
      }
      //********************************************** */

    })

    /*
    // Optionally request the permission early
    this.qrScanner.scan().then(barcodeData => {
      if(barcodeData.text){ // text: "...", format: "QR_CODE"
        if(this.db.currentRestaurant.tables.find((table:Table) => table.qrCode === barcodeData.text) !== undefined){
          this.util.presentToast('Dieser QR Code ist bereits einem anderen Tisch zugeordnet.')
          return
        }

        if(mode === ADD_TABLE){
          this.askForTableName(barcodeData.text)
        }else{
          this.changeQRCode(table, barcodeData.text)
        }
      } 
     }).catch(err => {
         this.util.log('Error', err);

         this.util.presentToast('QR Code des Tisches konnte nicht eingelesen werden.')
     });*/
  }



  back(){
    this.ngZone.run(() => this.router.navigate(['/owner-home']))
  }

  save() {
    this.db.updateRestaurant(this.db.currentRestaurantKey)
    this.util.presentToast("Angaben wurden gespeichert")
    this.ngZone.run(() => {
      this.db.currentPage = 'home'
      this.router.navigate(['/owner-home'])
    })
  }

}
